module.exports = __webpack_public_path__ + "img/cx1.1355f495.png";